import { Get } from "../../../api/apiHelper";
import { ResourceCentre } from "../../../interfaces/ResourceCentreInterface";

const getBranches = async (rcId?: number): Promise<Partial<Array<ResourceCentre>>> => {
  const { data } = await Get(`/api/subBranches?resourceCentreId=${rcId || ""}`);
  return data as Array<ResourceCentre>;
};
export default getBranches;
